import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "./index.css";

import { Navigation, Autoplay, Pagination } from "swiper";

const CustomCarousel = ({ pictures }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const prevNavigation = document.querySelector(".swiper-button-prev");
    const nextNavigation = document.querySelector(".swiper-button-next");

    if (show) {
      prevNavigation.classList.remove("swiper-button-hidden");
      nextNavigation.classList.remove("swiper-button-hidden");
    } else {
      prevNavigation.classList.add("swiper-button-hidden");
      nextNavigation.classList.add("swiper-button-hidden");
    }
  }, [show]);

  return (
    <div
      className='w-full h-full'
      onPointerEnter={() => {
        setShow(true);
      }}
      onPointerLeave={() => setShow(false)}
    >
      <Swiper
        navigation={true}
        modules={[Navigation, Autoplay, Pagination]}
        loop={true}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{
          clickable: true
        }}
      >
        {pictures && pictures.map((p) => {
          return (
            <SwiperSlide key={p.id}>
              <img
                src={p.picture}
                alt="banner"
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default CustomCarousel;
